import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.888 3.364A3.73 3.73 0 0 1 8.5 2.3c.977 0 1.917.381 2.612 1.064A3.62 3.62 0 0 1 12.2 5.947c0 .972-.393 1.9-1.088 2.584A3.73 3.73 0 0 1 8.5 9.595 3.73 3.73 0 0 1 5.888 8.53 3.62 3.62 0 0 1 4.8 5.947c0-.971.393-1.9 1.088-2.583M8.5 3.7c-.614 0-1.2.24-1.63.663-.43.422-.67.992-.67 1.584s.24 1.163.67 1.585c.43.423 1.016.663 1.63.663s1.2-.24 1.63-.663c.43-.422.67-.993.67-1.585s-.24-1.162-.67-1.584A2.33 2.33 0 0 0 8.5 3.7M7 12.542c-.614 0-1.2.24-1.63.663a2.22 2.22 0 0 0-.67 1.585v1.473a.7.7 0 1 1-1.4 0V14.79c0-.97.393-1.9 1.088-2.583A3.73 3.73 0 0 1 7 11.142h3a.7.7 0 1 1 0 1.4zm6.75-.663a.7.7 0 0 1 .7.7v1.51H16a.7.7 0 1 1 0 1.4h-1.55V17a.7.7 0 1 1-1.4 0v-1.51H11.5a.7.7 0 1 1 0-1.4h1.55v-1.511a.7.7 0 0 1 .7-.7",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }